export const apiConfig = {
  // root endpoint
  serviceApi:
    localStorage.getItem('service-api') !== null
      ? localStorage.getItem('service-api')
      : 'http://3.226.6.231:8080',
  serviceApiCM: localStorage.getItem('service-api-cm'),

  // api endpoints
  login: 'users/auth',
  logout: 'users/session',
  changepwd: 'users/changePassword'
};
